import { createAction } from "redux-starter-kit";
import { normalize } from "normalizr";
import { debounce } from "lodash";
import axios from "axios";

import { addEntities } from "../../entities";
import {
  FETCH_PAYMENT_ENTRIES_FAILURE,
  FETCH_PAYMENT_ENTRIES_REQUEST,
  FETCH_PAYMENT_ENTRIES_SUCCESS
} from "../types";

const handleResponse = (
  response,
  dispatch,
  paymentEntry,
  id,
  ordering,
  limit,
  filters
) => {
  const data = normalize(response.results, [paymentEntry]);
  dispatch(addEntities(data.entities));
  dispatch(
    createAction(FETCH_PAYMENT_ENTRIES_SUCCESS)({
      id,
      items: data.result,
      count: response.count,
      next: response.next,
      previous: response.previous,
      ordering,
      limit,
      filters
    })
  );
  return response;
};

const debounced = debounce(
  async (dispatch, schema, api, id, ordering, limit, filters) => {
    dispatch(
      createAction(FETCH_PAYMENT_ENTRIES_REQUEST)({
        id,
        limit,
        ordering,
        filters
      })
    );
    const response = await api.finances.queryPaymentEntries(
      id,
      ordering,
      limit,
      filters
    );
    return handleResponse(
      response,
      dispatch,
      schema.paymentEntry,
      id,
      ordering,
      limit,
      filters
    );
  },
  1000,
  { trailing: true }
);

const fetchPaymentEntries = (id, ordering, limit, filters = {}) => async (
  dispatch,
  getState,
  { api, schema }
) => {
  try {
    await debounced(dispatch, schema, api, id, ordering, limit, filters);
  } catch (err) {
    dispatch(createAction(FETCH_PAYMENT_ENTRIES_FAILURE)(err));
    throw err;
  }
};

export const next = (link, id, limit, ordering, filters) => async (
  dispatch,
  getState,
  { schema }
) => {
  try {
    dispatch(
      createAction(FETCH_PAYMENT_ENTRIES_REQUEST)({
        limit,
        ordering,
        filters
      })
    );

    const response = await axios.get(link);
    handleResponse(
      response.data,
      dispatch,
      schema.paymentEntry,
      id,
      ordering,
      limit,
      filters
    );
  } catch (err) {
    dispatch(createAction(FETCH_PAYMENT_ENTRIES_FAILURE)(err));
    throw err;
  }
};

export default fetchPaymentEntries;
